/**
 * Auto-loads country flag assets from src/assets/images/flags/.
 * Filenames must be lowercase ISO 3166-1 alpha-2 codes (e.g. us.svg, li.svg).
 */
const resolveAssetUrl = module => {
  if (!module) {
    return null
  }

  if (typeof module === 'string') {
    return module
  }

  if (typeof module.default === 'string') {
    return module.default
  }

  return null
}

const flagContext = require.context(
  '../../assets/images/flags',
  false,
  /\.svg$/i
)

const COUNTRY_FLAG_IMAGES = flagContext.keys().reduce((acc, filePath) => {
  const countryCode = filePath
    .replace('./', '')
    .replace(/\.svg$/i, '')
    .toUpperCase()
  const src = resolveAssetUrl(flagContext(filePath))

  if (src) {
    acc[countryCode] = src
  }

  return acc
}, {})

export const getCountryFlagSrc = countryCode => {
  if (!countryCode) {
    return null
  }

  return COUNTRY_FLAG_IMAGES[String(countryCode).trim().toUpperCase()] || null
}
